<template>
  <div class="subModal">
    <template v-if="loading">
      <span>Carregando ticket...</span>
    </template>
    <template v-else-if="assunto !== ''">
      <div class="item">{{ assunto }}</div>
      <div class="item" v-html="msg"></div>
      <div class="item res" v-html="'Resposta: '+chat"></div>
    </template>
    <template v-else>
      <span>Nenhum ticket aberto no momento.</span>
    </template>
  </div>
</template>

<script setup>


import { ref } from 'vue'

const props = defineProps(['ticketid'])

const chat = ref('')
const assunto = ref('')
const msg = ref('')
const loading = ref(false)

async function getChat() {
  if (!props.ticketid) return
  loading.value = true
  try {
    const res = await fetch(`/api/records/tickets/${props.ticketid}`, { credentials: 'include' })
    const data = await res.json()
    assunto.value = data.subject ?? data.title ?? ''
    msg.value     = data.message ?? ''
    const resR = await fetch(`/api/records/ticket_responses?filter=ticket_id,eq,${props.ticketid}&order=id,desc&page=1,1`, { credentials: 'include' })
    const dataR = await resR.json()
    chat.value = dataR.records?.[0]?.message ?? 'Sem resposta!'
  } finally {
    loading.value = false
  }
}

getChat()

</script>

<style scoped>
.subModal .item {
  float: left;
  width: 100%;
  height: auto;
  min-height: 36px;
  background-color: #EFF2F5;
  border-radius: 12px;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 16px;
  margin-bottom: 8px;
}

.subModal .item.res {
  background-color: #E4E9EE;
}

</style>
